/**
 * Data Transformers
 * Utility functions for transforming API data
 */

/**
 * Normalize karyawan payload from API
 * Handles different response formats: object, array, or nested data
 */
export const normalizeKaryawanPayload = (payload) => {
  const rawList = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
    ? payload.data
    : payload?.data
    ? [payload.data]
    : [payload];

  return rawList
    .filter(Boolean)
    .map((d) => ({
      id: d?.id != null ? String(d.id) : "",
      nama: (d?.nama ?? d?.name ?? "").toString().trim(),
      departemen: (d?.departemen ?? d?.departemen_kode ?? d?.dept ?? "")
        .toString()
        .trim(),
      nik: (d?.nik ?? "").toString(),
      photo_url: (d?.photo_url ?? "").toString(),
    }))
    .filter((x) => x.id);
};

/**
 * Extract age number from string
 * Example: "25 tahun" -> "25"
 */
const extractAgeNumber = (umur) => {
  if (!umur) return "";
  const match = String(umur).match(/\d+/);
  return match ? String(parseInt(match[0], 10)) : "";
};

/**
 * Map API patient data to form format
 */
export const mapApiPatient = (raw) => {
  return {
    id: raw.no_rawat,
    displayName: raw.nm_pasien?.trim() || "-",
    nama: raw.nm_pasien?.trim() || "",
    umur: extractAgeNumber(raw.umur),
    jenisKelamin:
      raw.jk === "L" ? "Laki-laki" : raw.jk === "P" ? "Perempuan" : "",
    tanggalKunjungan: raw.tgl_registrasi || "",
    layanan: raw.nm_poli || "",
  };
};

/**
 * Get initials from name
 * Example: "John Doe Smith" -> "JD"
 */
export const getInitials = (nama) => {
  if (!nama) return "";
  return nama
    .split(/\s+/)
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();
};

const DataTransformers = {
  normalizeKaryawanPayload,
  mapApiPatient,
  getInitials,
};

export default DataTransformers;